import { Form, InputGroup } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import { IoSearchOutline } from "react-icons/io5";

export default function InputSearch({
  value,
  onChange,
  placeholder = "",
  hideIcon = false,
  disabled,
  error = false,
  ...other
}) {
  const borderColor = error ? "#dc3545" : "var(--color-on-base-border-default)";

  const clearButton = (
    <InputGroup.Text
      id="basic-addon2"
      className="pointer-event"
      onClick={() => {
        if (!disabled) onChange("");
      }}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        border: "none",
        borderLeft: `1px solid ${borderColor}`,
      }}
    >
      <BsXLg className="opacity-50 text-title" />
    </InputGroup.Text>
  );

  return (
    <InputGroup
      style={{
        border: `1px solid ${borderColor}`,
        borderRadius: "8px",
        transition: "border-color 0.2s",
      }}
    >
      {!hideIcon &&
        (value ? (
          <InputGroup.Text
            id="basic-addon1"
            className="pointer-event"
            onClick={() => {
              if (!disabled) onChange("");
            }}
            style={{
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              pointerEvents: disabled ? "none" : "auto",
              border: "none",
              borderRight: `1px solid ${borderColor}`,
            }}
          >
            <BsXLg className="opacity-50 text-title" />
          </InputGroup.Text>
        ) : (
          <InputGroup.Text
            id="basic-addon1"
            className="border-end-0"
            style={{
              opacity: disabled ? 0.5 : 1,
              pointerEvents: disabled ? "none" : "auto",
              border: "none",
            }}
          >
            <IoSearchOutline
              className="text-title"
              size={22}
              style={{ color: "var(--color-on-base-content-high)" }}
            />
          </InputGroup.Text>
        ))}

      <Form.Control
        disabled={disabled}
        placeholder={placeholder}
        className="fw-light"
        value={value}
        style={{
          border: "none",
          boxShadow: "none",
          color: error && !value ? "#dc3545" : undefined,
        }}
        onChange={(e) => onChange(e.target.value)}
        {...other}
      />

      {hideIcon && value && clearButton}
    </InputGroup>
  );
}
